import React from 'react';
import API from '../conf/API';
import { request } from "../utils/request";
import { Events, JSEvent } from "../utils/JSEvent"
import { stringify } from 'postcss';
import BigNumber from 'bignumber.js';
import { CoinType, WalletAccount, Topics, GlobalSetting, IsFunctionOpen } from '../conf/Config';
import WebSocketClient from './WebSocketClient';
import cookie from 'react-cookies';
import { WalletService } from './WalletService'
import { AddressBook } from './AddressBook';
import { Firebase } from '../components/AuthComponent';

const conf = require("../conf.json");
export const loginCookie = "login_token";

const BN_ZERO = new BigNumber(0);

let wsMarket;
let wsExchange;

export const TransactionMethod = {
    Topup: 0,
    Withdraw: 1,
    Transfer: 2
}

export const CurrentCurrency = () => { return { name: "USD", symbol: "$", decimals: 2 } };

export let Connections = {
    market: wsMarket,
    exchange: wsExchange
}

/**
 * 全局计价货币的id，所有代币的价值都以计价货币为单位
 */
export let QuoteCoinID = 5;

export const KLineColor = {
    up: '#2FBD85',
    down: '#F6465D',
    equals: '#000000',
}

/**
 * DataCenter初始化数据列表
 */
const data_init = [
    { url: () => API.wallet_balance(() => DataCenter.accountId), name: "wallet", func: "wallet" },
    { url: () => API.exchange_symbolInfo(), name: "symbol", func: "wallet" },
    { url: () => API.market_coinList(), name: "thumb", func: "market" }
]

const currency_names = [
    "USD",
]

const handleLogin = ({ id, key }) => {
    DataCenter.setLoginInfo(id, key);
    DataCenter.init();
}

JSEvent.on(Events.Login.LoginSuccessful, handleLogin);
JSEvent.on(Events.System.Ready, e => {
    DataCenter.systemReady = true;
})


let DataCenter = {
    systemReady: false,
    accountId: null,
    loginKey: null,
    firebaseToken: null,
    showAccountInfo: true,
    customServiceId: null,
    //id: 0, username: "", phone: "", createTime: 0, referralCode:""
    profile: {},
    clientModuleId: parseInt(conf.clientInfo.moduleId, 16),
    serviceId: () => DataCenter.customServiceId == null ? "NGWallet-Web" : DataCenter.customServiceId,
    channel: conf.clientInfo.channel,
    wallet: null,
    symbol: null,
    thumb: null,
    plate: null,
    quotePrice: {},
    blockchains: [],
    /**
     * 在获取到profile之前的events，暂存，获取到profile后统一发送
     */
    eventsBeforeProfile: [],
    /**
     * 当前使用的区块链ID
     */
    currentBlockchainId: 2,
    blockchain: () => DataCenter.blockchains[DataCenter.currentBlockchainId],
    getBlockchina: key => {
        for (let i = 0; i < DataCenter.blockchains.length; i++) {
            const c = DataCenter.blockchains[i];
            if (c.key == key) {
                return c;
            }
        }
        return null;
    },

    init: (onFinished) => {
        const { accountId, loginKey, clientModuleId } = DataCenter
        const id = accountId;
        const key = loginKey;

        //读取区块链配置
        for (const bc in conf.blockchains) {
            const v = conf.blockchains[bc];
            DataCenter.blockchains.push({ key: bc, ...v });
        }

        //读取设置
        GlobalSetting.load(id);
        //建立连接

        if (IsFunctionOpen("market")) {
            wsMarket = new WebSocketClient({ name: 'market', url: API.ws_market_url() });

            wsMarket.connect(id, key, clientModuleId);
            Connections.market = wsMarket;
        }


        if (IsFunctionOpen("exchange")) {
            wsExchange = new WebSocketClient({ name: 'exchange', url: API.ws_exchange_url() });
            wsExchange.connect(id, key, clientModuleId);
            Connections.exchange = wsExchange;
        }

        //获取账户信息
        request(API.account_get_profile({
            id: DataCenter.accountId,
            token: DataCenter.loginKey,
            channel: DataCenter.channel,
            serviceId: DataCenter.serviceId()
        })).then(ret => {
            if (ret.error) {
                console.log(ret)
            } else {
                DataCenter.profile = ret.retObject;
                JSEvent.emit(Events.DataCenter.DATA_READY, {});

                if (DataCenter.eventsBeforeProfile.length > 0) {
                    DataCenter.eventsBeforeProfile.forEach(e => {
                        JSEvent.emit(e.name, e.data);
                    })
                    DataCenter.eventsBeforeProfile = [];
                }

            }
        })


        if (IsFunctionOpen("exchange")) {
            //订阅交易数据
            wsExchange.subscribe(Topics.exchange_user_wallet, (topic, msg) => {
                //wallet 有变化
                let balance = JSON.parse(msg.body);
                DataCenter.wallet[balance.walletAccount] = balance;
                console.log(`wallet[${balance.walletAccount}] updated: }`, balance)
                JSEvent.emit(Events.DataCenter.DATA_UPDATED, "wallet");
            })

            wsExchange.subscribe(Topics.exchange_user_trade, (topic, msg) => {
                //订单有变化
                let order = JSON.parse(msg.body);
                console.log(`order ${order.method}:`, order);

                switch (order.method) {
                    case "place":
                        JSEvent.emit(Events.Trade.ORDER_PLACED, order);
                        break;
                    case "cancel":
                        JSEvent.emit(Events.Trade.ORDER_CANCELED, order);
                        break;
                    case "update":
                    case "reject":
                        JSEvent.emit(Events.Trade.ORDER_UPDATED, order);
                        break;
                }
            })
        }


        if (IsFunctionOpen("market")) {
            //获取计价货币的现金价值
            currency_names.forEach(c => {
                request(API.market_quotePriceMap(c)).then(ret => {
                    if (ret.error == false) {
                        DataCenter.quotePrice[c] = ret.retObject;
                    }
                    console.log(c, ret.retObject);
                });
            })

            //订阅货币价值变化事件
            wsMarket.subscribe(Topics.marketQuotePrice, (topic, msg) => {
                DataCenter.quotePrice = JSON.parse(msg.body);
                JSEvent.emit(Events.DataCenter.DATA_UPDATED, "quotePrice");
                console.log("===marketQuotePrice===", topic, msg.body, DataCenter.quotePrice);
            })

            //订阅交易量变化事件
            wsMarket.subscribe(Topics.marketThumb, (topic, msg) => {
                const thumb = JSON.parse(msg.body);
                for (const id in thumb) {
                    DataCenter.updateThumbData(id, thumb[id]);
                }
                console.log("===marketThumb===", topic, msg.body, DataCenter.thumb);
            })
        }

        //请求数据
        for (let index = 0; index < data_init.length; index++) {
            const d = data_init[index];
            if (IsFunctionOpen(d.func)) {
                request(d.url()).then(ret => parseRespons(ret, d.name));
            }
        }

        if (onFinished != null) {
            onFinished();
        }


    },

    hasSymbolData: () => DataCenter.symbol != null,
    hasWalletData: () => DataCenter.wallet != null,
    hasThumbData: () => DataCenter.thumb != null,
    hasPlateData: () => DataCenter.plate != null,

    /**
     * 设置登陆信息
     * @param {int} id 
     * @param {String} key 
     */
    setLoginInfo: (id, key) => {
        DataCenter.accountId = id;
        DataCenter.loginKey = key;

    },

    logout: () => {
        cookie.remove(loginCookie)
        Firebase.signOut();
        DataCenter.accountId = null;
        DataCenter.firebaseToken = null;
    },

    isLogin: () => {
        return DataCenter.accountId != null
    },

    setClientInfo: (clientModuleId, channel) => {
        DataCenter.clientModuleId = clientModuleId;
        DataCenter.channel = channel;
    },

    /**
     * 更新指定交易对的实时数据
     * @param {int}} pairId 
     * @param {JSON} value 
     */
    updateThumbData: (pairId, value) => {
        DataCenter.thumb[pairId] = value;
        JSEvent.emit(Events.DataCenter.DATA_UPDATED, "thumb");
    },

    /**
     * 
     * @param {MessageResult} wallet 
     */
    updateWalletBalance: (wallet) => {
        parseRespons(wallet, "wallet")
    },

    /**
     * 获取指定账户下指定货币的余额
     * @param {WalletAccount}} walletAccount 
     * @param {CoinType} coinId 
     * @returns {BigNumber} balance
     */
    walletBalanceBN: (walletAccount, coinId, includeFrozen = true) => {
        let { wallet } = DataCenter;
        if (wallet == null) return BN_ZERO;
        const coin = DataCenter.getCoin(coinId);
        if (coin == null) return BN_ZERO;

        let balance = BN_ZERO;

        wallet.forEach(wa => {
            if (walletAccount == WalletAccount.All || wa.walletAccount == walletAccount) {
                let cb = new BigNumber(wa.coinBalance[coin.name]);
                if (includeFrozen) {
                    cb = cb.plus(wa.frozenBalance[coin.name]);
                }
                balance = balance.plus(cb);
            }

        })

        return balance;
    },

    // /**
    //  * 获取指定账户下所有token的数量总和(已计价货币为单位)以及现金价值总和
    //  * @returns {{BigNumber}totalCount ,{BigNumber}totalPrice}
    //  */
    // walletTotalPrice: (walletAccount) => {
    //     let total = new BigNumber(0);
    //     let quoteTotal = new BigNumber(0);
    //     const l = DataCenter.symbol.coins.length;
    //     const currency = CurrentCurrency();
    //     for (let i = 0; i < l; i++) {
    //         const coin = DataCenter.symbol.coins[i];
    //         const balance = DataCenter.walletBalance(walletAccount, coin.id);
    //         const price = DataCenter.getCoinQuotePrice(coin.id, QuoteCoinID, currency.name);
    //         const p = price.times(balance);
    //         const quoteCount = DataCenter.getCoinPriceInQuote(coin.id, balance, QuoteCoinID);
    //         quoteTotal = quoteTotal.plus(quoteCount);
    //         total = total.plus(p);
    //     }
    //     return { count: quoteTotal, price: total };
    // },

    /**
    * 获取指定账户下指定货币的余额，已转换为实际值
    * @param {WalletAccount}} walletAccount 
    * @param {CoinType} coinId 
    * @returns {BigNumber} balance
    */
    walletBalance: (walletAccount, coinId, includeFrozen = true) => {
        const bn = DataCenter.walletBalanceBN(walletAccount, coinId, includeFrozen);
        return Calculator.toNumber(bn, coinId);
    },

    /**
     * 获取指定账户下指定货币的冻结额度
     * @param {WalletAccount} walletAccount 
     * @param {CoinType} coinId 
     * @returns {BigNumber} balance
     */
    walletFrozen: (walletAccount, coinId) => {
        let { wallet } = DataCenter;
        if (wallet == null) return BN_ZERO;
        const coin = DataCenter.getCoin(coinId);
        if (coin == null) return BN_ZERO;

        let balance = BN_ZERO;

        wallet.forEach(wa => {
            if (walletAccount == WalletAccount.All || wa.walletAccount == walletAccount) {
                let cb = new BigNumber(wa.frozenBalance[coin.name]);
                balance = balance.plus(cb);
            }
        })
        return Calculator.toNumber(balance, coinId);;

    },

    getCoins: () => {
        if (DataCenter.symbol == null) return [];
        const bc = DataCenter.blockchain();
        const cq = DataCenter.getCoin(QuoteCoinID);
        const ng = DataCenter.getCoinByName("NEXG");
        const ret = [cq];
        if (ng != null && ng.getAddress(bc.key) != "disabled") {
            ret.push(ng);
        }
        DataCenter.symbol.coins.forEach(c => {
            if (c != cq && c != ng && c.getAddress(bc.key) != "disabled") {
                ret.push(c);
            }
        })

        return ret;
    },

    /**
     * 根据货币ID，获取货币对象数据
     * @param {int} coinId 
     * @returns Coin
     */
    getCoin: (coinId) => {
        if (DataCenter.symbol == null) return null;
        const coins = DataCenter.symbol.coins;
        for (let index = 0; index < coins.length; index++) {
            const coin = coins[index];
            if (coin.id == coinId) {
                return coin;
            }
        }
        return null;
    },

    /**
     * 根据货币名称，获取货币对象数据
     * @param {String}} coinName 
     * @returns Coin
     */
    getCoinByName: (coinName) => {
        if (DataCenter.symbol == null) return null;
        const coins = DataCenter.symbol.coins;
        for (let index = 0; index < coins.length; index++) {
            const coin = coins[index];
            if (coin.name.toLowerCase() == coinName.toLowerCase()) {
                return coin;
            }
        }
        return null;
    },

    /**
     * 根据交易对ID，获取交易对对象
     * @param {int} pairId 
     * @returns ExchangePairSpec
     */
    getCoinPair: (pairId) => {
        if (DataCenter.symbol == null) return null;
        const symbols = DataCenter.symbol.exchangePairs;
        for (let index = 0; index < symbols.length; index++) {
            const pair = symbols[index];
            if (pair.id == pairId) {
                return pair;
            }
        }
        return null;
    },

    /**
     * 根据给定的基准货币和计价货币，查找对应的交易对
     * @param {int} baseCoinId 
     * @param {int} quoteCoinId 
     * @returns ExchangePairSpec
     */
    getCoinPairByCoin: (baseCoinId, quoteCoinId) => {
        if (DataCenter.symbol == null) return null;
        const symbols = DataCenter.symbol.exchangePairs;
        for (let index = 0; index < symbols.length; index++) {
            const pair = symbols[index];
            if (pair.baseCoin.id == baseCoinId && pair.quoteCoin.id == quoteCoinId) {
                return pair;
            }
        }
        return null;
    },

    /**
     * 根据交易对ID，获取交易对的最新交易数据
     * @param {int} pairId 
     * @returns CoinBlockData
     */
    getCoinPairThumb: (pairId) => {
        let { thumb } = DataCenter;
        if (thumb == null) return null;
        const v = thumb[pairId];
        return v;
    },

    /**
     * 根据基准货币的数量，返回等值计价货币的数量
     * @param {int} coinId 基准货币id
     * @param {BigNumber} coinCount 基准货币数量，正常数量(大整数需要Calculator.toNumber转换为正常数量，统一单位)
     * @param {int} quoteId 计价货币id
     * @returns {BigNumber}
     */
    getCoinPriceInQuote: (coinId, coinCount, quoteId) => {
        if (coinId == quoteId) {
            return new BigNumber(coinCount);
        }
        const pair = DataCenter.getCoinPairByCoin(coinId, quoteId);
        if (pair == null) {
            return BN_ZERO;
        }

        const thumb = DataCenter.getCoinPairThumb(pair.id);

        //获取当前收盘价格
        const close = thumb == null ? 0 : new BigNumber(thumb.close);
        if (pair.close == null || pair.close == 0) {
            return BN_ZERO;
        }

        const quoteCount = close.times(coinCount);
        return quoteCount;
    },

    /**
     * 根据计价货币ID和法币名称，获取计价货币的单位价格
     * @param {int} quoteCoinId 
     * @param {String} currencyName 
     * @returns {BigNumber} price
     */
    getQuotePrice: (quoteCoinId, currencyName) => {
        let { quotePrice } = DataCenter;
        if (quotePrice == null) return BN_ZERO;
        const price = quotePrice[currencyName];
        if (price == null) return BN_ZERO;
        const strPrice = price[quoteCoinId];
        if (strPrice == null) return BN_ZERO;
        return new BigNumber(strPrice);
    },

    /**
     * 根据基准货币和计价货币，计算对应的单位价值（currencyName法币）
     * @param {int} baseCoinId
     * @param {int} quoteCoinId
     * @param {String} currencyName 
     * @return {BigNumber} price
     */
    getCoinQuotePrice: (baseCoinId, quoteCoinId, currencyName) => {
        let { quotePrice } = DataCenter;
        if (quotePrice == null) return BN_ZERO;

        const currPrice = quotePrice[currencyName];
        if (currPrice == null) return BN_ZERO;

        if (currPrice[baseCoinId] != null) {
            //基准货币本身就是计价货币
            const bnPrice = DataCenter.getQuotePrice(baseCoinId, currencyName);
            return bnPrice;
        }

        //获取计价货币的单位价值，默认计价货币都有对应的单位价值
        const bnPrice = DataCenter.getQuotePrice(quoteCoinId, currencyName);

        const pair = DataCenter.getCoinPairByCoin(baseCoinId, quoteCoinId);
        if (pair == null) return BN_ZERO;

        //获取交易对实时数据
        const thumb = DataCenter.getCoinPairThumb(pair.id);
        if (thumb == null) return BN_ZERO;

        //根据当前收盘价格，计算基准货币的单位价值
        return bnPrice.times(thumb.close);
    },

    /**
     * 返回指定交易对的当前状态
     * @param {SymbolSpec} coinPair 
     * @return {priceChange, percentChange, percent, percentSign, currencyPrice}
     */
    getCoinPairCurrentState: (coinPair) => {
        if (coinPair == null) return { priceChange: "up", percentChange: "up", percent: 0, percentSign: "+", currencyPrice: new BigNumber(0) }
        const { close, lastClose, open } = DataCenter.thumb[coinPair.id];

        const cc = CurrentCurrency();

        const currencyPrice = DataCenter.getQuotePrice(coinPair.quoteCoin.id, cc.name).times(close);

        const change = close - lastClose;
        let priceChange = 'equals';
        if (change >= 0) {
            priceChange = 'up';
        } else {
            priceChange = 'down';
        }

        // let colorSuffix = "price-equals";
        // if (change >= 0) {
        //     colorSuffix = "price-up";
        // } else if (change < 0) {
        //     colorSuffix = "price-down";
        // }

        let percent = (Math.abs(close - open) / open) * 100;
        if (open == 0 || close == 0) {
            percent = 0;
        }
        const sign = (close - open) >= 0 ? "+" : "-";
        const percentChange = (close - open) >= 0 ? 'up' : 'down'

        return {
            priceChange: priceChange, percentChange: percentChange, percent: percent, percentSign: sign, currencyPrice: currencyPrice
        };
    }

}

function parseRespons(ret, dataName) {
    if (ret.code == 0) {
        DataCenter[dataName] = ret.retObject;
        // if (dataName == "symbol") {
        //     DataCenter[dataName].exchangePairs.forEach(p => {
        //         p.name = () => `${p.baseCoin.name}_${p.quoteCoin.name}`
        //     });
        // }

        if (dataName == "symbol") {
            const blockChain = DataCenter.blockchain();
            DataCenter.symbol.coins.forEach(coin => {
                coin.getAddress = chainName => {
                    return coin.chainAddress[chainName];
                }

                Object.defineProperties(coin, {
                    address: {
                        get: () => coin.getAddress(DataCenter.blockchain().key)
                    }
                })

                const address = coin.getAddress(blockChain.key);
                if (address == "main") {
                    QuoteCoinID = coin.id;
                }
            })
        }

        console.log(dataName, ":", ret.retObject)

        if (DataCenter.profile.id == null) {
            //暂存事件
            DataCenter.eventsBeforeProfile.push({
                name: Events.DataCenter.DATA_UPDATED,
                data: dataName
            })
        } else {
            JSEvent.emit(Events.DataCenter.DATA_UPDATED, dataName);
        }
    } else {
        //TODO process error
    }
}





/**
 * OrderPriceCalculator
 */
export const Calculator = {


    /**
     * 根据货币的decimals，将大整数换算为实际值
     * @param {BigNumber|String} bigNumber 
     * @param {CoinType} coinId 
     * @returns {BigNumber} value
     */
    toNumber: (bigNumber, coinId) => {
        if (DataCenter.symbol == null) {
            return BN_ZERO;
        }

        let n = bigNumber;
        if (typeof n == "string" || typeof n == "number" || typeof n == "bigint") {
            n = new BigNumber(n);
        }

        const coin = DataCenter.getCoin(coinId);
        if (coin != null) {
            const unit = BigNumber(`1e${coin.decimals}`);
            const v = n.div(unit);
            return v;
        }
        return BN_ZERO;
    },

    /**
     * 根据货币的decimals，将实际值换算为大整数
     * @param {BigNumber} number 
     * @param {CoinType} coinId 
     * @returns {BigNumber} value
     */
    toBigNumber(number, coinId) {
        if (DataCenter.symbol == null) {
            return BN_ZERO;
        }
        const coin = DataCenter.getCoin(coinId);
        if (coin != null) {
            const unit = BigNumber(`1e${coin.decimals}`);
            const v = unit.times(number);
            return v;
        }
        return BN_ZERO;
    },

    /**
     * 根据货币的decimals，将大整数换算为实际值
     * @param {BigNumber} num 
     * @param {CoinType} coinName 
     * @returns {BigNumber} value
     */
    bigNumberToNumber: (num, coinName) => {
        if (DataCenter.symbol == null) {
            return BN_ZERO;
        }
        const coin = DataCenter.getCoinByName(coinName);
        if (coin != null) {
            const unit = BigNumber(`1e${coin.decimals}`);
            const v = num.dividedBy(unit);
            return v;
        }
        return BN_ZERO;
    },

    /**
     * 根据给定的计价货币，计算指定账户中所有资产的总和
     * @param {WalletAccount} walletAccount
     * @param {CoinType} quoteCoin 
     * @returns {BigNumber} totalBalance
     */
    calcTotalBalance: (walletAccount, quoteCoin = QuoteCoinID, includeFrozen = true) => {
        let { wallet } = DataCenter;
        if (wallet == null) return BN_ZERO;
        let total = BN_ZERO;
        wallet.forEach(w => {
            if (walletAccount == WalletAccount.All || walletAccount == w.walletAccount) {
                for (const cn in w.coinBalance) {
                    const coin = DataCenter.getCoinByName(cn);
                    if (coin == null) continue;
                    if (coin.id == quoteCoin) {
                        let balance = new BigNumber(w.coinBalance[cn]);
                        if (includeFrozen) {
                            balance = balance.plus(w.frozenBalance[cn]);
                        }
                        total = total.plus(balance);
                    } else {
                        const pairSpec = DataCenter.getCoinPairByCoin(coin.id, quoteCoin);
                        if (pairSpec != null) {
                            const thumb = DataCenter.getCoinPairThumb(pairSpec.id);
                            if (thumb == null) {
                                continue;
                            }
                            if (thumb.close > 0) {
                                let balance = new BigNumber(w.coinBalance[cn]);
                                if (includeFrozen) {
                                    balance = balance.plus(w.frozenBalance[cn])
                                }
                                const bnClose = new BigNumber(thumb.close);
                                const tv = bnClose.times(balance);
                                total = total.plus(tv);
                            }
                        }
                    }
                }
            }
        })
        return Calculator.toNumber(total, quoteCoin);
    },

    /**
     * 计算指定账户中指定货币的资产总和
     * @param {WalletAccount} walletAccount 
     * @param {CoinSpec} coin 
     * @param {int} quoteCoin 
     * @returns {BigNumber} balance
     */
    calcCoinBalance: (walletAccount, coin, quoteCoin = QuoteCoinID) => {

    }
}

export const generatedKLineDataList = (baseTimestamp = Date.now(), basePrice = 5000, dataSize = 800) => {
    const dataList = []
    let timestamp = Math.floor(baseTimestamp / 60 / 1000) * 60 * 1000
    let baseValue = basePrice
    const prices = []
    for (let i = 0; i < dataSize; i++) {
        baseValue = baseValue + Math.random() * 20 - 10
        for (let j = 0; j < 4; j++) {
            prices[j] = (Math.random() - 0.5) * 12 + baseValue
        }
        prices.sort()
        const openIdx = +Math.round(Math.random() * 3).toFixed(0)
        let closeIdx = +Math.round(Math.random() * 2).toFixed(0)
        if (closeIdx === openIdx) {
            closeIdx++
        }
        const volume = Math.random() * 50 + 10
        const kLineModel = {
            open: prices[openIdx],
            low: prices[0],
            high: prices[3],
            close: prices[closeIdx],
            volume: volume,
            timestamp
        }
        timestamp -= 60 * 1000
        kLineModel.turnover = (kLineModel.open + kLineModel.close + kLineModel.high + kLineModel.low) / 4 * volume
        dataList.unshift(kLineModel)
    }
    return dataList
}

export default DataCenter;